var React = require('react');

function Google (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 13.8666H26.6667V18.1333H16V13.8666Z","fill":"black","key":0}),React.createElement("path",{"d":"M24.2485 13.8667C24.4256 14.5504 24.5333 15.2608 24.5333 16C24.5333 20.7125 20.7125 24.5333 16 24.5333C11.2875 24.5333 7.46668 20.7125 7.46668 16C7.46668 11.2875 11.2875 7.46668 16 7.46668C18.1429 7.46668 20.096 8.26241 21.5947 9.56695L24.6251 6.53761C22.3488 4.46401 19.3237 3.20001 16.0032 3.20001C8.93228 3.20001 3.20001 8.93121 3.20001 16C3.20001 23.0688 8.93228 28.8 16.0032 28.8C26.6805 28.8 29.0869 18.8875 28.0853 13.8667H24.2485Z","fill":"black","key":1})]);
}

Google.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Google;

Google.default = Google;
